import React, { useContext } from "react";
import { CloudPremisePluginMenu, loginRequest, callApi, DataContext, PortalUser, usePluginProvider, CloudPremisePluginManager, User } from "@cloudpremise/portal_core";
import { useMsal } from "@azure/msal-react";
import { EventType, InteractionType } from '@azure/msal-browser';
import LoginIcon from '@mui/icons-material/Login';
import PinIcon from '@mui/icons-material/Pin';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import VpnKeyIcon from '@mui/icons-material/VpnKey';
import WindowIcon from '@mui/icons-material/Window';
import Lockicon from "@mui/icons-material/Lock";
import GoogleIcon from "@mui/icons-material/Google";
import GitHubIcon from "@mui/icons-material/GitHub";
import AppleIcon from "@mui/icons-material/Apple";
import FacebookIcon from "@mui/icons-material/Facebook";
import { useMaterialUIController } from "@cloudpremise/portal_core/src/themes/mui/context";

const menus = (): CloudPremisePluginMenu[] => {
    const { instance } = useMsal();
    const dataProvider = useContext(DataContext);
    const [controller, dispatch] = useMaterialUIController();
    const pluginManager: CloudPremisePluginManager = usePluginProvider();
    const authPlugin = pluginManager.getPluginByName("@cloudpremise/portal_auth");
    let menus = [];
    if(typeof(authPlugin.config) === "object" && authPlugin.config.hasOwnProperty("auth")){
        const authConfig = authPlugin.config.auth;
        if(authConfig.hasOwnProperty("salesforce") && authConfig.salesforce.status){
            menus = menus.concat([
                {
                    type: "menu_item",
                    name: "Login",
                    key: "login",
                    icon: <LoginIcon />,
                    route: "/auth/login",
                    privacy: "public",
                },
                {
                    type: "menu_item",
                    name: "Login With Code",
                    key: "login-code",
                    icon: <PinIcon />,
                    route: "/auth/login-code",
                    privacy: "public",
                },
            ]);
        }

        if(authConfig.hasOwnProperty("microsoft") && authConfig.microsoft.status){
            menus = menus.concat([
                {
                    type: "menu_item",
                    name: "Login With Microsoft",
                    key: "login-microsoft",
                    icon: <WindowIcon />,
                    route: "/auth/login-microsoft"+window.location.search,
                    privacy: "public",
                    onClick: (e) => {
                        e.preventDefault();
                        localStorage.removeItem("reactforce_logout");
                        instance.loginPopup(loginRequest).then((msData) => {
                            const object: PortalUser = {
                                sObjectTypeName: "PortalUser",
                                url: '/v1/identity/verification/microsoft',
                                method: 'POST',
                                headers: {
                                    'x-ms-access-token': msData.accessToken
                                },
                            };
                            callApi(dataProvider, object).then((data: any) => {
                                if(data && Array.isArray(data?.result) && data.result.length > 0){
                                    const verifiedEntity = new User(data.result[0]);
                                    localStorage.setItem("microsoft_login", "1");
                                    localStorage.setItem("identity_token", verifiedEntity.token);
                                    localStorage.setItem("verified_entity", JSON.stringify(verifiedEntity));
                                    localStorage.setItem("login_type", "microsoft");
                                    // verifiedEntity.token = null;
                                    instance.setActiveAccount(msData.account);
                                    dispatch({value: {user: verifiedEntity}, type: "UPDATE_STATE"});
                                }
                                // setState({dynamicObjectType: response.result, loading: false, formSaved: true});
                            }).catch((err) => {
                                let errorMessage = null;
                                // if(typeof(err) === "object" && err.hasOwnProperty("error")){
                                //     errorMessage = err.error;
                                // }else if(typeof(err) === "object" && err.hasOwnProperty("message")){
                                //     errorMessage = err.message;
                                // }
                                // setState({loading: false, errorMessage: errorMessage});
                            });
                        }).catch(e => {
                            console.log(e);
                        });
                    }
                },
            ]);
        }
        if(authConfig.hasOwnProperty("link") && authConfig.link.status){
            menus = menus.concat([
                {
                    type: "menu_item",
                    name: "Login with Link",
                    key: "login-link",
                    icon: <VpnKeyIcon />,
                    route: "/auth/login-link",
                    privacy: "public",
                },
            ]);
        }
        if(authConfig.hasOwnProperty("salesforce") && authConfig.salesforce.status){
            menus = menus.concat([
                {
                    type: "menu_item",
                    name: "Signup",
                    key: "signup",
                    icon: <LockOpenIcon />,
                    route: "/auth/signup",
                    privacy: "public",
                },
                {
                    type: "menu_item",
                    name: "Signup With Code",
                    key: "signup-code",
                    icon: <PinIcon />,
                    route: "/auth/signup-code",
                    privacy: "public",
                },
            ]);
        }
        let socialLogins = [];
        if(authConfig.hasOwnProperty("google") && authConfig.google.status){
            // localStorage.removeItem("google_login");
            socialLogins.push({
                type: "menu_item",
                name: "Google Sign-In",
                key: "google",
                icon: <GoogleIcon />,
                route: "/auth/google",
                privacy: "public"
            });
        }
        if(authConfig.hasOwnProperty("github") && authConfig.github.status){
            // localStorage.removeItem("github_login");
            socialLogins.push({
                type: "menu_item",
                name: "Github Sign-In",
                key: "github",
                icon: <GitHubIcon />,
                route: "/auth/github",
                privacy: "public"
            });
        }
        if(authConfig.hasOwnProperty("apple") && authConfig.apple.status){
            // localStorage.removeItem("apple_login");
            socialLogins.push({
                type: "menu_item",
                name: "Apple Sign-In",
                key: "apple",
                icon: <AppleIcon />,
                route: "/auth/apple",
                privacy: "public"
            });
        }
        if(authConfig.hasOwnProperty("facebook") && authConfig.facebook.status){
            // localStorage.removeItem("facebook_login");
            socialLogins.push({
                type: "menu_item",
                name: "Facebook Sign-In",
                key: "facebook",
                icon: <FacebookIcon />,
                route: "/auth/facebook",
                privacy: "public"
            });
        }
        menus = menus.concat([
            {
                type: "collapse",
                name: "Social Login",
                key: "social-login",
                icon: <Lockicon />,
                privacy: "public",
                collapse: socialLogins
            },
        ])
    }
    return menus;
};

export default menus;